export default {
    page_title: "Kevi | Campos do pedido",
    list: {
        title: "Campos do pedido",
        add_button: "Adicionar",
        edit_tooltip: "Editar campo",
        delete_tooltip: "Excluir campo",
    },
    form: {
        title: "Criando campo",
        name_label: "Nome",
        type_label: "Tipo",
        options_label: "Opções",
        option_placeholder: "Texto da opção",
        option_label: "Opção {0}",
        remove_option: "Remover",
        add_option: "Adicionar opção",
        back_button: "Voltar",
        save_button: "Salvar",
    },
    edit_modal: {
        title: "Editar campo personalizado",
        name_label: "Nome",
        type_label: "Tipo",
        options_label: "Opções",
        option_placeholder: "Texto da opção",
        option_label: "Opção {0}",
        remove_option: "Remover",
        add_option: "Adicionar opção",
    },
    confirm_delete: {
        title: "Gostaria de excluir",
        no_relations:
            "Esta ação é irreversível, tem certeza que deseja continuar?",
        linked_automations: "as seguintes automações:",
        linked_segments: "aos seguintes segmentos:",
        linked_warning: "Este campo está vinculado",
        warning_message:
            "É recomendado ajustar antes de remover, continuar agora pode gerar resultados inesperados.",
    },
    confirm_edit_name: {
        title: "Gostaria de editar o nome para",
        body: "Certifique-se de que o novo nome está correto antes de confirmar.",
    },
    notifications: {
        field_edited: "Campo de pedido editado",
        field_updated: "Campo atualizado",
        field_added: "Campo adicionado",
        field_deleted: "Campo personalizado excluído",
        min_options_warning:
            "Você deve adicionar pelo menos duas opções preenchidas.",
    },
    sr: {
        name_label: "Nome",
    },
};
